var map = {
	"./bottleshot_chardonnay.png": 80,
	"./bottleshot_magnanime.png": 81,
	"./bottleshot_malbec.png": 82,
	"./bottleshot_pinot.png": 83,
	"./bottleshot_signature.png": 84,
	"./bottleshot_tinto.png": 85,
	"./cuadrados_claro.png": 26,
	"./cuadrados_oscuro.png": 36,
	"./mancha_beige.png": 30,
	"./puntos_chardonnay.png": 157,
	"./puntos_magnanime.png": 158,
	"./puntos_malbec.png": 159,
	"./puntos_pinot.png": 160,
	"./puntos_signature.png": 161,
	"./puntos_tinto.png": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 156;